import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { formatCurrency } from '../../utils/baseUtils';
import { headerCls } from '../../data/columns';

export const buildFinanceColumns = ({ companyId }) => [
  {
    title: <span className={headerCls}>Type</span>,
    key: 'type',
    width: 160,
    render: (_, finance) => (
      <>
        <Tooltip id={`finance-type-${finance.id}`} />
        <span
          data-tooltip-id={`finance-type-${finance.id}`}
          data-tooltip-content={finance.code}
          className="text-sm font-semibold text-slate-900 dark:text-slate-100"
        >
          {finance?.financetype?.name}
        </span>
      </>
    ),
  },
  {
    title: <span className={headerCls}>Explanation</span>,
    key: 'explanation',
    render: (_, finance) => {
      if (finance.details?.length > 0) {
        return (
          <Link
            // Absolute, not relative. Relative resolved against whatever
            // route rendered this table, which worked only while the legacy
            // Finance screen at /dashboard/finance was the single caller —
            // from /dashboard/finance/payouts it produced
            // /dashboard/finance/payouts/<id>/orders, which matches nothing
            // and drops the reader on the dashboard. The row's destination
            // does not depend on where the row is drawn.
            to={`/dashboard/finance/${companyId}/orders?financeid=${finance.id}`}
            className="text-sm text-blue-600 hover:underline dark:text-sky-400"
          >
            {`${moment(finance.startdate)
              .utcOffset(0)
              .format('MMMM DD')} - ${moment(finance.enddate)
              .utcOffset(0)
              .format('MMMM DD')} (${finance.store?.name})`}
          </Link>
        );
      }
      return (
        <span className="text-sm text-slate-600 dark:text-slate-300">
          {finance.description}
        </span>
      );
    },
  },
  {
    title: <span className={headerCls}>Create Date</span>,
    key: 'createdate',
    width: 160,
    render: (_, finance) => (
      <span className="text-sm tabular-nums text-slate-600 dark:text-slate-400">
        {moment
          .utc(finance.createdate)
          .local()
          .format(
            moment().year() === moment(finance.createdate).year()
              ? 'MMMM Do'
              : 'MMMM Do YYYY',
          )}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Total</span>,
    key: 'amount',
    width: 140,
    align: 'right',
    render: (_, finance) => (
      <span className="text-sm font-bold tabular-nums text-slate-900 dark:text-slate-100">
        {formatCurrency(finance.amount)}
      </span>
    ),
  },
];
